import { state } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export default {
  ...state
}
